module.exports = __webpack_public_path__ + "img/theater_round_16.7da10856.png";